import React, { useEffect, useMemo, useState } from "react";
import { formatDateTime } from "./rootDashboardUtils";

export default function CampusSessionsSection({ campusSessions = [], onExpireSession }) {
  const [expiringId, setExpiringId] = useState(null);
  const [modal, setModal]           = useState(null);

  const modalSession = modal?.session || null;
  const modalLabel   = useMemo(
    () => modalSession?.nombre || modalSession?.username || "este usuario",
    [modalSession]
  );
  const isModalOpen = Boolean(modal);

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    if (isModalOpen) document.body.classList.add("modal-open");
    else document.body.classList.remove("modal-open");
    return () => document.body.classList.remove("modal-open");
  }, [isModalOpen]);

  const closeModal = () => setModal(null);

  const confirmExpire = async () => {
    if (!onExpireSession || !modalSession) return;
    setExpiringId(modalSession.id);
    try {
      await onExpireSession(modalSession.id);
      closeModal();
    } catch (err) {
      console.error("Error caducando sesión campus", err);
    } finally {
      setExpiringId(null);
    }
  };

  const activeCount = campusSessions.filter((s) => s.activa).length;

  return (
    <div className="row g-3 mb-4">
      <div className="col-12">
        <div className="management-card root-section-card h-100">
          <div className="root-card-header">
            <div>
              <h6 className="root-card-title mb-1">Sesiones Campus</h6>
              <small className="text-muted">Estudiantes y docentes · activas y recientes</small>
            </div>
            <span className="management-pill root-chip">
              <i className="bi bi-mortarboard" />
              {activeCount}
            </span>
          </div>

          <div className="management-table-wrapper">
            <table className="table management-table mb-0">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Tipo</th>
                  <th>Usuario</th>
                  <th>IP</th>
                  <th>Inicio</th>
                  <th>Expira</th>
                  <th className="text-end">Acción</th>
                </tr>
              </thead>
              <tbody>
                {campusSessions.length ? (
                  campusSessions.map((row) => (
                    <tr key={row.id}>
                      <td>
                        <span className="root-session-user">
                          <span
                            className={`root-session-dot ${row.activa ? "" : "is-inactive"}`}
                            title={row.activa ? "Activa" : "Caducada"}
                            aria-hidden="true"
                          />
                          {row.nombre}
                        </span>
                      </td>
                      <td>
                        <span className={`badge ${row.tipo === "docente" ? "text-bg-primary" : "text-bg-info"}`}>
                          {row.tipo === "docente" ? "Docente" : "Estudiante"}
                        </span>
                      </td>
                      <td>{row.username || row.email}</td>
                      <td>{row.ip}</td>
                      <td>{formatDateTime(row.creado)}</td>
                      <td>{row.expira ? formatDateTime(row.expira) : "Sin expiración"}</td>
                      <td className="text-end">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger root-session-action"
                          disabled={!onExpireSession || expiringId === row.id || !row.activa}
                          onClick={() => setModal({ session: row })}
                        >
                          {expiringId === row.id ? "Caducando..." : "Caducar"}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center text-muted py-3">
                      Sin sesiones campus registradas
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal confirmación caducar */}
      {isModalOpen && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.45)" }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h6 className="modal-title">Caducar sesión campus</h6>
                <button type="button" className="btn-close" onClick={closeModal} />
              </div>
              <div className="modal-body pt-0">
                <p className="small mb-0">
                  ¿Caducar la sesión de <strong>{modalLabel}</strong>? El usuario deberá iniciar sesión nuevamente.
                </p>
              </div>
              <div className="modal-footer border-0">
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={closeModal}>
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  disabled={expiringId === modalSession?.id}
                  onClick={confirmExpire}
                >
                  {expiringId === modalSession?.id ? "Caducando..." : "Caducar"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
